<ng-template #annotationCounters>
  <po-tag
    *ngIf="requiredActionsCount > 0"
    class="sr-counter-tag sr-counter-tag--clickable"
    [class.sr-counter-tag--actions]="showActions"
    [class.sr-counter-tag--muted]="!showActions"
    [p-value]="actionsCounterLabel"
    [p-type]="showActions ? 'warning' : 'neutral'"
    p-orientation="horizontal"
    [p-tooltip]="actionsCounterTooltip"
    p-tooltip-position="top"
    p-append-in-body="true"
    (p-click)="toggleActions()">
  </po-tag>
  <po-tag
    *ngIf="suggestionsCount > 0"
    class="sr-counter-tag sr-counter-tag--clickable"
    [class.sr-counter-tag--suggestions]="showSuggestions"
    [class.sr-counter-tag--muted]="!showSuggestions"
    [p-value]="suggestionsCounterLabel"
    [p-type]="showSuggestions ? 'info' : 'neutral'"
    p-orientation="horizontal"
    [p-tooltip]="suggestionsCounterTooltip"
    p-tooltip-position="top"
    p-append-in-body="true"
    (p-click)="toggleSuggestions()">
  </po-tag>
  <po-tag
    *ngIf="sonarRulesCount > 0"
    class="sr-counter-tag sr-counter-tag--sonar"
    [p-value]="'Regras Sonar: ' + sonarRulesCount"
    p-type="neutral"
    p-orientation="horizontal"
    p-tooltip="Total de regras Sonar detectadas nas ações"
    p-tooltip-position="top"
    p-append-in-body="true">
  </po-tag>
</ng-template>

<!-- Selo "a versão revisada ainda é a atual?". Desatualizado, abre o que mudou num modal. -->
<ng-template #freshnessBadge>
  <po-tag
    *ngIf="changesetFreshness as freshness"
    class="sr-counter-tag"
    [class.sr-freshness-tag--current]="freshness.state === 'current'"
    [class.sr-freshness-tag--outdated]="freshness.state === 'outdated'"
    [class.sr-counter-tag--muted]="freshness.state === 'checking'"
    [class.sr-counter-tag--clickable]="!!freshness.newer?.length"
    [p-value]="freshness.label"
    [p-type]="freshnessTagType(freshness)"
    p-orientation="horizontal"
    [p-tooltip]="freshness.tooltip"
    p-tooltip-position="right"
    p-append-in-body="true"
    (p-click)="openFreshnessDetails()">
  </po-tag>
</ng-template>

<ng-template #annotationsToggleButton>
  <div class="diff-annotations-toggle" *ngIf="hasFindings">
    <po-button
      [p-kind]="!annotationsPanelCollapsed ? 'secondary' : 'tertiary'"
      [p-label]="annotationsToggleLabel"
      p-tooltip="Mostrar/ocultar ações e sugestões (Alt+3)"
      p-tooltip-position="top"
      p-append-in-body="true"
      (p-click)="toggleAnnotationsPanel()">
    </po-button>
  </div>
</ng-template>

<ng-template #workspaceExpandButton>
  <div
    class="diff-expand-toggle"
    [class.diff-expand-toggle--icon-only]="toolbarCompact">
    <po-button
      [p-kind]="expandButtonKind"
      [p-icon]="isFullscreen ? 'po-icon-screen-minimize' : 'po-icon-screen-full'"
      [p-label]="expandButtonLabel"
      [p-tooltip]="isFullscreen ? 'Sair da tela cheia (Esc)' : 'Expandir para tela cheia'"
      [attr.aria-label]="isFullscreen ? 'Contrair' : 'Expandir'"
      p-tooltip-position="top"
      p-append-in-body="true"
      (p-click)="toggleFullscreen()">
    </po-button>
  </div>
</ng-template>

<ng-template #annotationsSidePanel>
  <!-- Sem análise, a lateral mostra por que não há achados, no lugar onde eles apareceriam. -->
  <aside
    class="sr-diff-side"
    *ngIf="!answer && emptyAnalysisMessage"
    [style.--sr-panel-height]="annotationsPanelHeight + 'px'">
    <div class="sr-surface sr-annotations-surface sr-annotations-surface--side">
      <po-info p-label="Análise" [p-value]="emptyAnalysisMessage"></po-info>
    </div>
  </aside>
  <aside
    class="sr-diff-side"
    *ngIf="answer && showFindingsPanel"
    [style.--sr-panel-height]="annotationsPanelHeight + 'px'">
    <div class="sr-surface sr-annotations-surface sr-annotations-surface--side">
      <app-annotations-panel
        [requiredActions]="answer.required_actions ?? []"
        [suggestions]="answer.suggestions ?? []"
        [activeLine]="activeAnnotationLine"
        [showActions]="showActions"
        [showSuggestions]="showSuggestions"
        [resourceType]="resourceType"
        [resourceId]="resourceId"
        [answerArtifactId]="answerArtifactId"
        [feedbackByFindingId]="feedbackByFindingId"
        [otherFeedbackByFindingId]="otherFeedbackByFindingId"
        (annotationClicked)="onAnnotationClicked($event)"
        (showAllRequested)="showAllAnnotations()"
        (feedbackChanged)="feedbackChanged.emit($event)"
        (otherFeedbackRemoved)="otherFeedbackRemoved.emit($event)">
      </app-annotations-panel>
    </div>
  </aside>
</ng-template>

<ng-container *ngIf="!isStandalone">
  <div class="sr-diff-workspace"
       [class.sr-diff-workspace--with-side]="showSidePanel"
       [class.sr-diff-workspace--fullscreen]="isFullscreen">
    <div class="sr-diff-main">
      <div class="sr-surface sr-diff-surface">
        <div
          class="diff-toolbar"
          [class.diff-toolbar--compact]="toolbarCompact"
          [class.diff-toolbar--ultra-compact]="toolbarUltraCompact">
          <div class="diff-toolbar-left">
            <ng-container *ngTemplateOutlet="annotationCounters"></ng-container>
            <span
              *ngIf="changesetContextLabel"
              class="diff-changeset-context">
              {{ changesetContextLabel }}
            </span>
            <ng-container *ngTemplateOutlet="freshnessBadge"></ng-container>
          </div>
          <div class="diff-toolbar-right">
            <div class="diff-stats" *ngIf="!toolbarUltraCompact && (diffPair.stats.added > 0 || diffPair.stats.removed > 0)">
              <span class="diff-stat-added">+{{ diffPair.stats.added }}</span>
              <span class="diff-stat-removed">−{{ diffPair.stats.removed }}</span>
            </div>

            <div class="diff-nav">
              <po-button
                p-kind="tertiary"
                p-icon="po-icon-arrow-up"
                [p-disabled]="diffChangeCount === 0"
                p-tooltip="Alteração anterior (Shift+F7)"
                p-tooltip-position="top"
                p-append-in-body="true"
                (p-click)="prevDiff()">
              </po-button>
              <span class="diff-nav-counter" *ngIf="diffChangeCount > 0">
                {{ diffChangeIndex }}/{{ diffChangeCount }}
              </span>
              <span class="diff-nav-counter" *ngIf="diffChangeCount === 0">—</span>
              <po-button
                p-kind="tertiary"
                p-icon="po-icon-arrow-down"
                [p-disabled]="diffChangeCount === 0"
                p-tooltip="Próxima alteração (F7)"
                p-tooltip-position="top"
                p-append-in-body="true"
                (p-click)="nextDiff()">
              </po-button>
            </div>

            <div class="diff-mode-toggle">
              <po-button
                [p-kind]="!diffInline ? 'secondary' : 'tertiary'"
                [p-label]="sideBySideLabel"
                [p-disabled]="!canUseSideBySide"
                [p-tooltip]="canUseSideBySide ? 'Lado a lado (Alt+1)' : 'Lado a lado disponível em telas largas'"
                p-tooltip-position="top"
                p-append-in-body="true"
                (p-click)="setDiffMode(false)">
              </po-button>
              <po-button
                [p-kind]="diffInline ? 'secondary' : 'tertiary'"
                p-label="Inline"
                p-tooltip="Inline (Alt+2)"
                p-tooltip-position="top"
                p-append-in-body="true"
                (p-click)="setDiffMode(true)">
              </po-button>
            </div>

            <ng-container *ngTemplateOutlet="annotationsToggleButton"></ng-container>
            <ng-container *ngIf="showWorkspaceActions || isFullscreen">
              <ng-container *ngTemplateOutlet="workspaceExpandButton"></ng-container>
            </ng-container>
          </div>
        </div>

        <po-code-editor
          #diffEditor
          [ngModel]="[diffPair.original, diffPair.modified]"
          [p-language]="diffPair.language"
          p-show-diff="true"
          p-readonly="true"
          p-theme="vs"
          [p-height]="diffHeight">
        </po-code-editor>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="annotationsSidePanel"></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="isStandalone">
  <div class="sr-diff-workspace"
       [class.sr-diff-workspace--with-side]="showSidePanel"
       [class.sr-diff-workspace--fullscreen]="isFullscreen">
    <div class="sr-diff-main">
      <div class="sr-surface sr-diff-surface">
        <div
          class="diff-toolbar"
          [class.diff-toolbar--compact]="toolbarCompact"
          [class.diff-toolbar--ultra-compact]="toolbarUltraCompact">
          <div class="diff-toolbar-left">
            <ng-container *ngTemplateOutlet="annotationCounters"></ng-container>
            <span
              *ngIf="changesetContextLabel"
              class="diff-changeset-context">
              {{ changesetContextLabel }}
            </span>
            <ng-container *ngTemplateOutlet="freshnessBadge"></ng-container>
          </div>
          <div class="diff-toolbar-right">
            <ng-container *ngTemplateOutlet="annotationsToggleButton"></ng-container>
            <ng-container *ngIf="showWorkspaceActions || isFullscreen">
              <ng-container *ngTemplateOutlet="workspaceExpandButton"></ng-container>
            </ng-container>
          </div>
        </div>
        <po-code-editor
          #sourceEditor
          [ngModel]="standaloneSource"
          [p-language]="sourceLanguage"
          p-readonly="true"
          p-theme="vs"
          [p-height]="diffHeight">
        </po-code-editor>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="annotationsSidePanel"></ng-container>
  </div>
</ng-container>

<po-modal
  #freshnessModal
  p-title="O que mudou depois do review"
  p-size="xl"
  [p-primary-action]="freshnessModalClose">
  <ng-container *ngIf="changesetFreshness as freshness">
    <div class="po-row">
      <po-info
        class="po-md-6"
        [p-label]="freshnessReviewedTitle(freshness)"
        [p-value]="freshnessReviewedLabel(freshness)">
      </po-info>
      <po-info
        class="po-md-6"
        p-label="Situação"
        [p-value]="freshness.summary">
      </po-info>
    </div>
    <po-table
      class="sr-freshness-table"
      [p-columns]="freshnessColumns"
      [p-items]="freshnessRows"
      [p-loading]="freshnessRowsLoading"
      [p-height]="freshnessRows.length > freshnessTableMaxRows ? 360 : 0"
      [p-hide-columns-manager]="true"
      [p-striped]="true"
      p-spacing="small">
    </po-table>
  </ng-container>
</po-modal>
